import {
  Backdrop,
  Box,
  CircularProgress,
  Container,
  Paper,
  Snackbar,
  Theme,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { makeStyles } from '@material-ui/styles';
import React, { useContext, useState } from 'react';
import { Redirect } from 'react-router-dom';
import Footer from '../components/Footer';
import Header from '../components/Header';
import ProfileForm, { IPayloadSave } from '../components/ProfileForm';
import UserContext from '../contexts/UserContext';
import { updateDisplayName } from '../services/auth';
import { uploadAvatar } from '../services/avatar';
import { auth } from '../services/firebase';
const useStyles = makeStyles<Theme>((theme) => ({
  paper: {
    backgroundColor: '#564F70',
    padding: theme.spacing(2),
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
  },
}));

const EditProfile = () => {
  const { loading, paper } = useStyles();
  const { state, dispatch } = useContext(UserContext);
  const [snackbar, setSnackbar] = useState<ISnackbar>({
    severity: undefined,
    open: false,
    message: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const editPhotoUrl = async (photoUrl: string) => {
    if (photoUrl.startsWith('blob')) {
      const newPhotoUrl = await uploadAvatar(photoUrl, auth.currentUser!.uid);
      dispatch({
        type: 'UPDATE_PHOTO_URL',
        payload: { photoUrl: newPhotoUrl },
      });
    }
  };
  const editDisplayName = async (displayName: string | undefined) => {
    if (displayName && state.user?.displayName !== displayName) {
      console.log('update display name');
      await updateDisplayName(displayName);
      dispatch({ type: 'UPDATE_DISPLAY_NAME', payload: { displayName } });
    }
  };
  const handleSave = async (payload: IPayloadSave) => {
    setSubmitting(true);
    await Promise.all([
      editPhotoUrl(payload.photoUrl),
      editDisplayName(payload.data.displayName),
    ]);
    setSubmitting(false);
    setSnackbar({
      message: 'Successfully changed profile',
      severity: 'success',
      open: true,
    });
  };
  if (!state.user) {
    return <Redirect to="/" />;
  }
  const getCurrentProvider = () => {
    const providerId = auth.currentUser?.providerData[0]?.providerId;
    if (!providerId) return '';
    else if (providerId.match('google')) return 'Google';
    else if (providerId.match('facebook')) return 'facebook';
    return '';
  };
  return (
    <>
      <Header />
      <Container maxWidth="md">
        <Box p={2}>
          <Paper className={paper}>
            {state.user && (
              <ProfileForm
                email={state.user.email}
                avatarUrl={state.user.photoUrl}
                displayName={state.user.displayName}
                onSave={handleSave}
                provider={getCurrentProvider()}
              />
            )}
          </Paper>
        </Box>
      </Container>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => {
          setSnackbar((state) => ({ ...state, open: false }));
        }}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
      <Footer />
      <Backdrop open={submitting} className={loading}>
        <CircularProgress color="secondary" />
      </Backdrop>
    </>
  );
};

export default EditProfile;
